import { styled } from '@mui/material/styles';
import { Link } from 'core/common/ui/ui-kit';

export const ContainerStyled = styled('div')`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const LinkStyled = styled(Link)`
  text-decoration: underline;
  color: ${({ theme }) => theme.palette.text.main};
`;

export const NumberListStyled = styled('ol')`
  color: ${({ theme }) => theme.palette.text.main};
  counter-reset: item;
`;

export const ListItemStyled = styled('li')`
  display: block;
  margin-top: 10px;
  color: ${({ theme }) => theme.palette.text.main};

  &::before {
    font-weight: bold;
    content: counters(item, '.') '. ';
    counter-increment: item;
  }
`;

export const UnorderedListStyled = styled('ul')`
  padding-left: 10px;

  & > li::before {
    content: '• ';
    counter-increment: none;
  }
`;

export const LetterListStyled = styled('ol')`
  counter-reset: item;
  list-style: none;

  & > li::before {
    margin-right: 40px;
    font-weight: bold;
    content: counter(item, upper-alpha) '. ';
    counter-increment: item;
  }
`;

export const WrapperStyled = styled('div')`
  margin-left: 50px;
`;

export const BoldStyled = styled('b')``;

export const UnderlineStyled = styled('u')``;
